<tiime-dialog [isLoading]="isLoading()" loaderPosition="end" (cancel)="cancel()">
  <mat-dialog-content class="dialog-content" mat-dialog-content data-cy="contract-dialog-content">
    <div class="dialog-left-content">
      <div class="left-content-header">
        <div class="flex row align-center gap-10">
          <app-contract-status-select
            label=""
            [contractId]="contractForm.id.value"
            [contractStatus]="contractForm.contractStatus.value"
            [contractStatusAt]="contractForm.statusAt.value"
            [contractStatusBy]="contractForm.statusBy.value"
            [statusDisabled]="contractForm.archivedAt.value"
            (selectionChange)="changeContractStatus($event)"
          ></app-contract-status-select>
          @if (!contractForm.archivedAt.value) {
            @if (contractForm.contractStatus.value === ContractStatus.draft) {
              <button
                tiime-button
                icon
                strocked
                color="primary"
                tiimeTooltip="Envoyer le contrat"
                (click)="sendContract(SendContractType.signature)"
              >
                <mat-icon svgIcon="icon-mail"></mat-icon>
              </button>
            }
            @if (contractForm.sentAt.value) {
              <app-contract-reminders-button
                [contractId]="contractForm.id.value"
                [contractStatus]="contractForm.contractStatus.value"
                [reminderCount]="contractForm.reminderCount.value"
                [nextReminderDate]="contractForm.nextReminderDate.value"
                [nextReminderDateModifiedAt]="contractForm.nextReminderDateModifiedAt.value"
                [nextReminderDateModifiedBy]="contractForm.nextReminderDateModifiedBy.value"
                (addReminder)="addReminder($event)"
                (updateNextReminderDate)="updateNextReminderDate($event)"
              ></app-contract-reminders-button>
            }
            @if (contractForm.contractStatus.value === ContractStatus.sent) {
              <button
                tiime-button
                icon
                strocked
                color="primary"
                tiimeTooltip="Annuler l'envoi"
                (click)="changeContractStatus(ContractStatus.draft)"
              >
                <mat-icon svgIcon="icon-mail-off"></mat-icon>
              </button>
            }
          }
          @if (contractForm.id.value) {
            @if (!contractForm.archivedAt.value) {
              <button
                tiime-button
                icon
                strocked
                color="primary"
                [disabled]="contractForm.contractStatus.value === ContractStatus.sent"
                [tiimeTooltip]="contractForm.contractStatus.value | map: mapToArchiveTooltipMessage"
                (click)="setContractArchived(true)"
              >
                <mat-icon svgIcon="icon-archived"></mat-icon>
              </button>
            }
            @if (contractForm.archivedAt.value) {
              <button
                tiime-button
                icon
                strocked
                color="primary"
                tiimeTooltip="Désarchiver le contrat"
                (click)="setContractArchived(false)"
              >
                <mat-icon svgIcon="icon-unarchived"></mat-icon>
              </button>
            }
          }
        </div>
        @if (contractForm.sentAt.value; as sentAt) {
          <span class="infos-label">{{ 'Envoyé le' | atBy: sentAt : contractForm.sentBy.value?.fullName }}.</span>
        }
        @if (contractForm.signedAt.value; as signedAt) {
          <span class="infos-label">{{ 'Signé le' | atBy: signedAt : contractForm.signedBy.value?.fullName }}.</span>
        }
        @if (contractForm.lostAt.value; as lostAt) {
          <span class="infos-label">
            {{ 'Indiqué perdu le' | atBy: lostAt : contractForm.lostBy.value?.fullName }}.
            @if (contractForm.lossReason.value; as lossReason) {
              Motif "{{ lossReason | codeAndLabel: (contractLossReasons$ | async) }}".
            }
            @if (contractForm.lossComment.value; as lossComment) {
              Commentaire "{{ lossComment }}".
            }
          </span>
        }
        @if (contractForm.archivedAt.value; as archivedAt) {
          <span class="infos-label">
            {{ 'Archivé le' | atBy: archivedAt : contractForm.archivedBy.value?.fullName }}.
          </span>
        }
        @if (contractForm.isLastSignatureExpired.value && contractForm.contractStatus.value === ContractStatus.sent) {
          <tiime-alert [displayIcon]="false" warn>
            Le lien de signature a expiré. Il convient de renvoyer ou relancer le contrat par mail ou SMS pour le
            renouveler.
          </tiime-alert>
        }
      </div>
      @if (contractForm.company.value) {
        <app-contract-contact-container [contractForm]="contractForm"></app-contract-contact-container>
      } @else {
        <app-contract-prospect-container
          [prospect]="contractForm.prospect.value"
          [acquisitionChannels]="acquisitionChannels()"
        ></app-contract-prospect-container>
      }
    </div>
    <div class="dialog-right-content">
      <span mat-dialog-title>{{ contractForm?.id?.value ? 'Détails' : 'Ajouter un' }} contrat</span>
      <app-contract-form
        class="contract-form"
        [contractForm]="contractForm"
        [modelOffers]="modelOffers$ | async"
        [annexModels]="annexModels$ | async"
        [tasks]="tasks$ | async"
        [partner]="partner$ | async"
        [businessUnits]="businessUnits$ | async"
        [contractAnnexLineTypes]="contractAnnexLineTypes()"
        [contractAnnexLineCharges]="contractAnnexLineCharges()"
        (downloadFile)="downloadContractFile($event)"
        (openFileInNewTab)="openContractFileInNewTab($event)"
      ></app-contract-form>
      <div class="actions">
        <button tiime-button color="accent" strocked (click)="cancel()" data-cy="contract-dialog-cancel-btn">
          Annuler
        </button>
        <button
          tiime-button
          color="accent"
          raised
          [disabled]="contractForm.disabled"
          (click)="submitContract()"
          data-cy="contract-dialog-save-btn"
        >
          {{ contractForm?.id?.value ? 'Enregistrer' : 'Ajouter' }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</tiime-dialog>
